import { Container } from "../../components/UI/container/Container";
import { MeetingRoom } from "../../components/pages/user/videomeeting/MeetingRoom";
import { Fragment } from "react";
import { MyHead } from "../../components/pages/MyHead";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { BackToProfile } from "../../components/pages/user/BackToProfile";
import { Footer } from "../../components/pages/homepage/footer/Footer";

// @ts-ignore
export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
    },
  };
}

function UserAppointmentPage() {
  const { t } = useTranslation("common");

  return (
    <Fragment>
      <MyHead title={t("video-calls")} description={t("video-calls")} />
      <BackToProfile />
      <Container noHeight>{<MeetingRoom />}</Container>
      <Footer isVisible />
    </Fragment>
  );
}

export default UserAppointmentPage;
